import { useRef } from "react";
import "./dragAndDropUploaderFiles.css";
import FileCard from "./FileCard";
import { BsFileEarmarkArrowDownFill } from "react-icons/bs";

const DragAndDropUploaderFiles = ({
  fileInputList,
  setFileInputList,
  acceptedExtensions = [".pdf"],
  maxFileSize = 5,
}) => {
  const fileInputRef = useRef(null);

  const handleFileSelect = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      const validFiles = Array.from(files).filter(
        (file) =>
          // file.type === "application/pdf" &&
          !fileInputList.some((existingFile) => existingFile.name === file.name)
      );
      setFileInputList((prevList) => [...prevList, ...validFiles]);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    const pdfFiles = files.filter(
      (file) =>
        // file.type === "application/pdf" &&
        !fileInputList.some((existingFile) => existingFile.name === file.name)
    );
    setFileInputList((prevList) => [...prevList, ...pdfFiles]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFileDelete = (index) => {
    setFileInputList((prevList) => prevList.filter((_, i) => i !== index));
  };

  const renderFileCards = () => {
    return fileInputList.map((record, index) => (
      <FileCard
        key={index}
        file_name={record.name ? record.name : "Nombre Desconocido"}
        file_size={
          record.size ? Math.round(record.size / 1024) : "Tamaño Desconocido"
        }
        onDelete={() => handleFileDelete(index)}
      />
    ));
  };

  const fileInputProps = {
    type: "file",
    accept: acceptedExtensions.join(", "),
    onChange: handleFileChange,
    style: { display: "none" },
    ref: fileInputRef,
    multiple: true,
  };

  return (
    <div aria-label="drag-and-drop-container">
      {fileInputList?.length < maxFileSize && (
        <div
          className="drop-and-drag-section py-5"
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
          <input {...fileInputProps} />
          <div
            style={{
              width: 70,
              height: 70,
              background: "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
              borderRadius: 18,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
              fontSize: 42,
              boxShadow: "0 4px 12px rgba(37, 99, 235, 0.15)",
              color: "#2563eb",
            }}
          >
            <BsFileEarmarkArrowDownFill />
          </div>
          <div className="p-3">
            <h4
              onClick={handleFileSelect}
              style={{
                cursor: "pointer",
                color: "#2563eb",
                fontWeight: "bold"
              }}>
              Selecciona tus archivos
            </h4>
            <h4>o arrástralos a esta sección</h4>
            <input {...fileInputProps} />
          </div>
        </div>
      )}
      <div
        className="selected-files"
        style={
          fileInputList.length > 2
            ? { maxHeight: "180px", overflowY: "scroll", marginTop: "5px" }
            : {}
        }
      >
        {fileInputList.length > 0 && renderFileCards()}
      </div>
    </div>
  );
};

export default DragAndDropUploaderFiles;
